import type { PostHog } from "posthog-js";

let posthog: Promise<PostHog> | null = null;

/** Loads PostHog and records the page view. A page on localhost sends no analytics. */
export function startAnalytics(): void {
  if (window.location.host.includes("localhost")) {
    return;
  }
  posthog = import("posthog-js").then(({ default: client }) => {
    client.init(import.meta.env.VITE_POSTHOG_API_KEY, {
      api_host: "/ingest", // proxied to posthog server-side: see vercel.json
      ui_host: "https://us.posthog.com",
      capture_pageview: false,
      autocapture: false,
      loaded: (loaded) => {
        if (import.meta.env.DEV) loaded.debug();
      },
      disable_surveys: true,
    });
    client.capture("$pageview", { $current_url: window.location.href });
    return client;
  });
}

export function identify(authId: string): void {
  posthog?.then((client) => client.identify(authId));
}

export function capture(event: string): void {
  posthog?.then((client) => client.capture(event));
}

export function setSentryUser(user: {
  sub?: string;
  name?: string;
  email?: string;
}): void {
  import("@sentry/browser").then((Sentry) =>
    Sentry.setUser({ id: user.sub, username: user.name, email: user.email }),
  );
}
